import React from 'react';
import { useBlockNoteEditor, useComponentsContext } from '@blocknote/react';
import { Gesture } from '@mui/icons-material';

export function SignatureButton() {
  const editor = useBlockNoteEditor();
  const Components = useComponentsContext();

  const handleClick = () => {
    // Get current position
    const currentBlock = editor.getTextCursorPosition().block;
    
    // Insert [SIGNATURE] on its own line
    editor.insertBlocks(
      [
        {
          type: 'paragraph',
          content: '[SIGNATURE]',
        },
      ],
      currentBlock,
      'after'
    );
  };

  if (!Components) {
    return null;
  }

  return (
    <Components.FormattingToolbar.Button
      mainTooltip="Insert Signature"
      onClick={handleClick}
      isSelected={false}
    >
      <Gesture style={{ width: 18, height: 18 }} />
    </Components.FormattingToolbar.Button>
  );
}